import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonServiceService } from '../services/common-service.service';
import { MatDialog } from '@angular/material/dialog';
import { UserWelcomeComponent } from 'src/app/layout/footer/user-welcome/user-welcome.component';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GDPRComponent } from '../gdpr/gdpr.component';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, OnDestroy {
  [x: string]: any;
  homeData: any = [];
  impactData: any = [];
  employeeData: any = [];
  partnerData: any = [];
  fullname: any = '';
  emaiID: any = '';
  message: any = '';
  initialIndex = 0;
  imageCount = 4;
  endIndex: number = this.imageCount;
  imgData: any = [];
  userEmail: any = '';
  imageClick = false;
  submitStatus = true;
  ourImpactData: any = [];
  url: any;
  videoEmbedUrl = '';
  videoEmbedValid = false;
  videoPlaying = false;
  videoLoaded = false;
  private videoLoadTimer?: ReturnType<typeof setTimeout>;
  private readonly videoLoadTimeoutMs = 10000;
  private readonly youtubeMessageHandler = (event: MessageEvent) => this.handleYouTubeMessage(event);
  readonly videoPosterUrl =
    'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?q=80&w=1313&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';
  indicatorCountData: any = [
    { name: 'Sectors Supported', key: 'sectors_in_projects', id: '11'},
    { name: 'MSMEs Supported', key: 'msme_in_sectors', id: '12'},
    { name: 'Workers Impacted', key: 'male_workers_in_instep', id: '13'},
];
isFullname = false;
isEmail = false;
isMessage = false;
isValidEmail = false;
public contactUsForm!: FormGroup;
gdprChecked = false;
readonly contactEmailFallback = '';
contactDisplayEmail = '';
contactEmailLoading = !!environment.contactUsSectionId;




  constructor(private commonService: CommonServiceService,  private formBuilder: FormBuilder ,
              public dialog: MatDialog, private snackBar: MatSnackBar, private router: Router,
              private sanitizer: DomSanitizer) {
    this.contactUsFormControls();
  }
  public isLoggedin: any = new BehaviorSubject('false');


  contactUsFormControls(): void {
    this.contactUsForm = this.formBuilder.group({
      fullname: ['', [Validators.required]],
      emaiID: ['', [Validators.required, Validators.email]],
      message:  ['', [ Validators.required]]
    });
  }

  alphabetsOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return /^[a-zA-Z\s]+$/.test(String.fromCharCode(charCode));
  }

  restrictSpecialChar(event: any): boolean{
    const charCode = (event.which) ? event.which : event.keyCode;
    return /^[^*|\":<>[\]{}`\\()';@&$]+$/.test(String.fromCharCode(charCode));
  }

  ngOnInit(): void {
    const userToken = sessionStorage.getItem('token');
    userToken ? this.isLoggedin.next(true) : this.isLoggedin.next(false);
    window.addEventListener('message', this.youtubeMessageHandler);
    this.getHomePageData();
    this.outImpactSectionData();
    this.loadContactUsDisplayEmail();
  }

  loadContactUsDisplayEmail(): void {
    const sectionId = environment.contactUsSectionId;
    if (!sectionId) {
      this.contactDisplayEmail = this.contactEmailFallback;
      return;
    }
    this.contactEmailLoading = true;
    this.commonService.getPageDetails(sectionId).subscribe({
      next: (res) => {
        const email = res?.data?.[0]?.link?.trim();
        this.contactDisplayEmail = res?.success && email ? email : this.contactEmailFallback;
      },
      error: () => {
        this.contactDisplayEmail = this.contactEmailFallback;
      },
      complete: () => {
        this.contactEmailLoading = false;
      },
    });
  }

  get contactMailtoHref(): string {
    return `mailto:${this.contactDisplayEmail}?subject=Hello`;
  }

  toDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  showHomeSection(item: { slug?: string; order?: number; isActive?: boolean }, order: number): boolean {
    return item?.slug === 'home' && item?.order === order && item?.isActive !== false;
  }

  outImpactSectionData(): void {
    this.commonService.resourceCenterData().subscribe(res => {
      if (res.success){
        this.ourImpactData = res.data.filter((ele: any) => ele.types === 'impact stories');
        this.setKeyForIndicatorsCount();
        this.getSummaryCardsData();
      }
    });
  }

  getHomePageData(): void {
    this.commonService.homePageData().subscribe(response => {
      if (response.success){
        this.homeData = response?.data;
        const teamSection = this.homeData.find((ele: any) => ele?.model === 'Teammember');
        this.setActiveTeamMembers(teamSection?.data);

        const videoLink = this.homeData.filter((ele: any) => ele?.order === 2);
        if (videoLink.length && videoLink[0]?.link) {
          if (!videoLink[0].link.split('/').includes('live')) {
            const myId = this.getId(videoLink[0].link);
            videoLink[0].link = myId !== 'error'
              ? `https://www.youtube.com/embed/${myId}`
              : '';
          } else if (!videoLink[0].link.split('/').includes('embed')) {
            videoLink[0].link = videoLink[0].link.replace('/live/', '/embed/');
          } else {
            videoLink[0].link = videoLink[0].link.replace('/live/', '/');
          }
          this.videoEmbedUrl = videoLink[0].link;
          this.videoEmbedValid = !!this.extractVideoId(this.videoEmbedUrl);
          void this.validateYouTubeVideo(this.videoEmbedUrl).then(valid => {
            this.videoEmbedValid = valid;
          });
        }

        const partnerData = this.homeData.find((ele: any) => ele?.model === 'Partners');
        const partnerImage = partnerData ? partnerData.data : [];
        this.partnerData = [...partnerImage];
        if (partnerImage.length && partnerImage.length < 6){
          this.partnerData = [...partnerImage, ...partnerImage];
        }

        // this code part is for multiple image
        const multiImageObj = this.homeData.find((ele: any) => ele?.order === 4);
        const finalData =  multiImageObj.banner.split(',');
        this.homeData.map((data: any) => {
          if (data.order === 4){
            data.imgArray = finalData;
          }
        });
      }
    });
    this.getimpactStoriesData();
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.youtubeMessageHandler);
    this.clearVideoLoadTimer();
  }

  playVideo(): void {
    if (!this.videoEmbedUrl || !this.videoEmbedValid) {
      return;
    }
    this.startVideoPlayback();
  }

  private startVideoPlayback(): void {
    this.clearVideoLoadTimer();
    this.videoPlaying = true;
    this.videoLoaded = false;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.videoEmbedUrl}?rel=0&autoplay=1&enablejsapi=1`
    );
    this.videoLoadTimer = setTimeout(() => this.onVideoLoadFailed(), this.videoLoadTimeoutMs);
  }

  private handleYouTubeMessage(event: MessageEvent): void {
    if (!this.videoPlaying || event.origin !== 'https://www.youtube.com') {
      return;
    }
    const data = this.parseYouTubeMessage(event.data);
    if (!data?.event) {
      return;
    }
    if (data.event === 'onReady') {
      this.onVideoReady();
    }
    if (data.event === 'onError') {
      this.onVideoLoadFailed();
    }
  }

  private parseYouTubeMessage(data: unknown): { event?: string } | null {
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch {
        return null;
      }
    }
    if (typeof data === 'object' && data !== null) {
      return data as { event?: string };
    }
    return null;
  }

  private onVideoReady(): void {
    this.clearVideoLoadTimer();
    this.videoLoaded = true;
  }

  onVideoLoadFailed(): void {
    this.clearVideoLoadTimer();
    this.videoPlaying = false;
    this.videoLoaded = false;
    this.url = undefined;
  }

  private validateYouTubeVideo(embedUrl: string): Promise<boolean> {
    const videoId = this.extractVideoId(embedUrl);
    if (!videoId) {
      return Promise.resolve(false);
    }
    const watchUrl = encodeURIComponent(`https://www.youtube.com/watch?v=${videoId}`);
    return fetch(`https://www.youtube.com/oembed?format=json&url=${watchUrl}`)
      .then(response => response.ok)
      .catch(() => true);
  }

  private extractVideoId(embedUrl: string): string | null {
    const match = embedUrl.match(/embed\/([^?&/]+)/);
    return match?.[1] ?? null;
  }

  private clearVideoLoadTimer(): void {
    if (this.videoLoadTimer) {
      clearTimeout(this.videoLoadTimer);
      this.videoLoadTimer = undefined;
    }
  }

  getId(url: string): string {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      return match[2];
    }
    return 'error';
  }

  getimpactStoriesData(): void {
    this.commonService.impactStoriesData().subscribe(response => {
      if (response.success){
        this.impactData = response?.data;
      }
    });
  }

  getemployeeData(): void {
    this.commonService.employeeData().subscribe(response => {
      if (response.success){
        this.setActiveTeamMembers(response?.data);
      }
    });
  }

  private setActiveTeamMembers(members: any[] | undefined): void {
    this.employeeData = (members ?? []).filter((member: { isActive?: boolean }) => member.isActive === true);
    this.initialIndex = 0;
    this.endIndex = this.imageCount;
    this.imgData = this.employeeData.slice(this.initialIndex, this.endIndex);
  }

  gdprConfirmation(): void {
    this.postContactUsInfo();
  }

  privacyStatement(): void {
    const dialogRef = this.dialog.open(GDPRComponent, {
      width: '700px',
      panelClass: 'gdpr-portalDialog',
      data: {}
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
    });
  }

  postContactUsInfo(): void {
    const data = {
      fullname: this.contactUsForm.controls.fullname.value,
      email: this.contactUsForm.controls.emaiID.value,
      message: this.contactUsForm.controls.message.value
  };
    this.commonService.contactUsInfo(data).subscribe(res => {
      if (res.success){
        this.openSnackBar(['Thankyou for Contacting Us !!'], '', false);
        this.contactUsForm.reset({ emitEvent: false });
        Object.keys(this.contactUsForm.controls).forEach(controlName => {
          const control = this.contactUsForm.get(controlName);
          if (!control) { return; }
          control.setErrors(null);
          control.markAsPristine();
          control.markAsUntouched();
        });
      }
    }, (error) => {
      this.openSnackBar(error?.error?.message ? error?.error?.message : 'failed !', '', true);
    });
  }

  openSnackBar(message: any, action = '', isError: boolean= false): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: isError ? ['primary'] : ''
  });
}

  nextImages(buttonClicked: any): void {
    if (buttonClicked === 'forward'){
      if (this.initialIndex + this.imageCount < this.employeeData.length){
        this.initialIndex = this.initialIndex + this.imageCount;
        this.endIndex = this.endIndex + this.imageCount;
      }
      else { return; }
    }
    else{
      if (this.initialIndex - this.imageCount >= 0){
        this.initialIndex = this.initialIndex - this.imageCount;
        this.endIndex = this.endIndex - this.imageCount;
      }
      else { return; }
    }
    this.imgData = this.employeeData.slice(this.initialIndex, this.endIndex);
  }
  subscribeUser(): void {
    const data = {
      email: this.userEmail
    };
    this.commonService.subscribeUser(data).subscribe(res => {
      if (res.success) {
        this.userEmail = '';

      }
    });
  }

  lbBox(e: any): void {
    this.imageClick = false;
}

openMail(): void {
  window.open(this.contactMailtoHref, '_self');
}
openSignUpForm(): void {
  this.router.navigate(['home']);
  const dialogRef = this.dialog.open(SignUpComponent, {
    width: '750px',
    panelClass: 'signUp-dialog-class',
    disableClose: true,
  });
}
 setIndicatorsCount(data: any): void {
  this.ourImpactData = this.ourImpactData.map((el: any) => {
    data.forEach((dc: any) => {
      if (dc.short_key === el?.key){
        // for static value statement
        if (el.key === 'sectors_supported'){
          el.indicatorsCount = 12 ;
        }else if (el.key === 'msme_supported'){
        // for static value statement
          el.indicatorsCount = 118;
        }else{
          // original Statement
          el.indicatorsCount = dc[dc?.short_key];
        }
      }
    });
    return el;
  });
 }
 setKeyForIndicatorsCount(): void {
  this.ourImpactData = this.ourImpactData.map((el: any) => {
    this.indicatorCountData.forEach((e: any) => {
      if (e.id === el.unique_id){
        el.key = e.key;
      }
    });
    return el;
  });
 }

stripHtmlTags(input: any): string {
  const doc: any = new DOMParser().parseFromString(input, 'text/html');
  const images = doc.querySelectorAll('img');

  // Check if there is text content in the body
  const textContent = doc.body.textContent || '';

  // Truncate text content to a limit of 500 characters
  const truncatedText = textContent.length > 500 ? textContent.substring(0, 500) + '...' : textContent;

  // Clone the original body without modifying it
  const clonedBody = doc.body.cloneNode(true);

  // Clear the original body content
  doc.body.innerHTML = '';

  // Append the truncated text content to the modified body
  doc.body.appendChild(document.createTextNode(truncatedText));

  // Append the original images back to the modified body
  images.forEach((image: any) => {
    const clonedImage = image.cloneNode(true);
    clonedImage.classList.add('img-fluid'); // Add your desired class here
    clonedImage.classList.add('mt-4');
    doc.body.appendChild(clonedImage);
  });

  // Create a new container element
  const container = document.createElement('div');

  // Append the modified content to the container
  container.appendChild(doc.body);

  // Get the HTML content of the container
  const result = container.innerHTML;

  return result;
}

stripHtmlTagsForCard(input: any, limit: number): string {
  const doc: any = new DOMParser().parseFromString(input, 'text/html');

  // Extract plain text content without HTML tags
  const textContent = doc.body.textContent || '';

  // Truncate text content to a limit of 150 characters
  let truncatedText = '';
  if (limit > 0){
    truncatedText  = textContent.length > limit ? textContent.substring(0, limit) + '...' : textContent;
  }
  else{
    truncatedText = textContent;
  }

  return truncatedText;
}

createCustomMessage(customMessage: any): string {
  let snackMessage = '';
  for (const key in customMessage){
     if (!this[key]){
      if (snackMessage) {
      snackMessage += ', ';
      }
      snackMessage += customMessage[key];
     }
  }
  return snackMessage;
}
validateMethod(type: string): void {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (type === 'fullname'){
    this.isFullname = false;
  }
  if (type === 'emailId' && this.emaiID){
      this.isValidEmail = emailRegex.test(this.emaiID);
    }
  if (type === 'message'){
    this.isMessage = false;
  }
}
}
